import { useState } from 'react';

const navItems = [
  { label: '追更动态', href: '#updates' },
  { label: '常见问题', href: '#faq' },
  { label: '关于UU', href: '#about' },
  { label: '热门题材', href: '#topics' },
  { label: '分类索引', href: '#index' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70 h-[68px] flex items-center">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between">
        <a href="#" className="flex items-center gap-2 no-underline">
          <span className="font-heading text-2xl text-primary-500 tracking-wide">UU漫画</span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          <a href="#" className="whitespace-nowrap px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md">首页</a>
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap px-3 py-2 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors rounded-md"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden absolute top-[68px] left-0 right-0 bg-background-50 border-b border-background-200/70 px-4 py-4 flex flex-col gap-2">
          <a href="#" className="whitespace-nowrap px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors" onClick={() => setMobileOpen(false)}>首页</a>
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap px-4 py-3 text-sm font-medium text-foreground-600 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}